import keyMirror from 'keymirror';

export const LeadEdgeRoofSelectorActionTypes = keyMirror({
  SELECT_ROOF_LEAD_EDGE: undefined,
  CLEAR_ROOF_LEAD_EDGE: undefined,
  DELETE_ALL_LEAD_EDGES: undefined,
});
